import { render } from "./participate-success.vue?vue&type=template&id=7e77a781&scoped=true"
const script = {}

import "./participate-success.vue?vue&type=style&index=0&id=7e77a781&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e77a781"]])

export default __exports__